import * as React from "react";

export default () => {
  return <div>Välj vilket lägenhet som ska vara delaktig i den angivna avgiftsgruppen. Andelar justera för alla lägenheter samtidigt.</div>;
};
